import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { newsActions } from '../actions/news.actions';
import { HttpService } from '../services/http.service';

@Injectable({
    providedIn: 'root',
})
export class NewsEffects {
    private readonly actions = inject(Actions);
    private readonly httpService = inject(HttpService);

    getNews$ = createEffect(() => {
        return this.actions.pipe(
            ofType(newsActions.getNews),
            mergeMap(() =>
                this.httpService.getNews().pipe(
                    map((news) => newsActions.getNewsSuccess({ news })),
                    catchError(() => of(newsActions.getNewsError())),
                ),
            ),
        );
    });
}
